"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.anonymizeComment = exports.anonymizeContent = exports.anonymizeField = void 0;
const lodash_1 = __importDefault(require("lodash"));
function _anonimizeString(str) {
    return 'X'.repeat(str.length);
}
function anonymizeField(field) {
    const result = Object.assign({}, field);
    ['initial', 'prompt', 'hint', 'placeholder'].forEach((key) => {
        if (field[key])
            result[key] = _anonimizeString(field[key]);
    });
    return result;
}
exports.anonymizeField = anonymizeField;
function anonymizeContent(content) {
    const result = lodash_1.default.cloneDeep(content);
    ['text', 'value', 'fontSizeCalculatedFor.text', 'dateStamp', 'stamp.dateTime.text'].forEach((path) => {
        const val = lodash_1.default.get(content, path);
        if (val)
            lodash_1.default.set(result, path, _anonimizeString(val));
    });
    return result;
}
exports.anonymizeContent = anonymizeContent;
function anonymizeComment(operation) {
    const result = Object.assign({}, operation);
    if (operation.message)
        result.message = _anonimizeString(operation.message);
    return result;
}
exports.anonymizeComment = anonymizeComment;
//# sourceMappingURL=anonymizer.js.map